import { useState } from 'react'
import { IFilteredPoolVehicleList } from 'types/PoolVehicleType'

export default function usePoolVehicleResModal() {
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)
  const [selectedVehicle, setSelectedVehicle] = useState<IFilteredPoolVehicleList>()

  const closeModal = () => setModal(false)
  const openModal = (vehicle?: IFilteredPoolVehicleList) => {
    setModal(true)
    if (vehicle) setSelectedVehicle(vehicle)
  }

  return {
    selectedVehicle,
    setSelectedVehicle,
    modal,
    openModal,
    closeModal,
    notification,
    setNotification,
  }
}
